// src/components/Gallery.jsx
import { useState } from "react";
import Marquee from "react-fast-marquee"; 
import "../../../assets/css/container/gallery.css";
import Modal from "../modal";
import { Link } from "react-router-dom";

import G2 from "../../../assets/img/gallery/G2.JPG";
import G12 from "../../../assets/img/gallery/G12.jpg";
import G31 from "../../../assets/img/gallery/G31.jpg";
import G35 from "../../../assets/img/gallery/G35.jpg";
import G46 from "../../../assets/img/gallery/G46.jpg";
import G40 from "../../../assets/img/gallery/G40.jpg";
import G30 from "../../../assets/img/gallery/G30.jpg";
import G43 from "../../../assets/img/gallery/G43.jpg";
import G28 from "../../../assets/img/gallery/G28.jpg";
import G9 from "../../../assets/img/gallery/G9.jpg";
import G16 from "../../../assets/img/gallery/G16.jpg";
import G60 from "../../../assets/img/gallery/G60.jpg";
import G62 from "../../../assets/img/gallery/G62.jpg";
import G63 from "../../../assets/img/gallery/G63.jpg";

const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState({ src: "", alt: "" });

    // Updated categories
  const categories = [
    "All",
    "Braids & Cornrows",
    "Locs & Twists",
    "Weaves & Sew-In Styles",
    "Kids Styles",
    "Natural & Curly Styles",
  ];

  const B = "Braids & Cornrows";
  const L = "Locs & Twists";
  const W = "Weaves & Sew-In Styles";
  const K = "Kids Styles";
  const N = "Natural & Curly Styles";

  const images = [
    // Natural & Curly
    { src: G2,  category: N, alt: "Soft curls / natural finish" },
    { src: G62,  category: N, alt: "Soft curls / natural finish" },
    { src: G63,  category: N, alt: "Soft curls / natural finish" },


    // Locs & Twists
    { src: G12, category: L, alt: "Senegalese twists – full length" },
    { src: G46, category: L, alt: "Locs updo bun" },
    { src: G60, category: L, alt: "Soft/boho locs – long" },

    // Weaves & Sew-In
    { src: G31, category: W, alt: "Curly sew-in with leave-out" },
    { src: G30, category: W, alt: "Sleek layered sew-in" },

    // Braids & Cornrows
    { src: G35, category: B, alt: "Stitch feed-in braids" },
    { src: G40, category: B, alt: "Designer cornrows with curls" },
    { src: G16, category: B, alt: "Feed-in cornrows with a low braided bun" },

    // Kids
    { src: G43, category: K, alt: "Kids braided buns with curls" },
    { src: G28, category: K, alt: "Kids braided cornrows styled into a curly ponytail with neat edges" },
    { src: G9, category: K, alt: "Kids cornrow hairstyle with zigzag and straight braid design" },
  ];

  const handleCategoryClick = (category) => setSelectedCategory(category);
  const handleImageClick = (src, alt) => {
    setCurrentImage({ src, alt });
    setIsModalOpen(true);
  };
  const closeModal = () => setIsModalOpen(false);

  return (
    <div className="gallery-section">
      <h1>Welcome to Kadi&apos;s Hair Gallery</h1>
      <p>Your style, our passion.</p>

      {/* Category Tabs 
      <div className="category-tabs">
        {categories.map((category) => (
          <button
            key={category}
            className={`tab-button ${selectedCategory === category ? "active" : ""}`}
            onClick={() => handleCategoryClick(category)}
          >
            {category}
          </button>
        ))}
      </div>
      */}

      {/* Scrolling Marquee Section */}
      <div className="galleries">
        <div className="gallery-scroll">
          <Marquee
            gradient={false}
            speed={80}
            pauseOnHover={true}
            pauseOnClick={true}
            direction="left"
          >
            {images
              .filter((img) => selectedCategory === "All" || img.category === selectedCategory)
              .map((image, index) => (
                <div
                  key={index}
                  className="gallery-item"
                  onClick={() => handleImageClick(image.src, image.alt)}
                >
                  <img className="gallery-photo" src={image.src} alt={image.alt || `Gallery ${index + 1}`} />
                </div>
              ))}
          </Marquee>

          {/* View More Button */}
          <div className="view-more-container">
            <Link to="/gallery" className="view-more-btn">
              View More
            </Link>
          </div>

          {/* Modal */}
          <Modal
            isOpen={isModalOpen}
            onClose={closeModal}
            imageSrc={currentImage.src}
          />
        </div>
      </div>
    </div>
  );
};

export default Gallery;
